import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { CyborgUIModule } from '@cyborg-monorepo/common/angular/cyborg-ui';
import { SearchStateService } from '../research/services/search-state.service';
import { SearchUrlService } from '../research/services/search-url.service';
import { AllActiveFiltersComponent } from './components/all-active-filters/all-active-filters.component';
import { ContactCyborgComponent } from './components/contact-cyborg/contact-cyborg.component';
import { DateRangeFilterComponent } from './components/custom-filters/date-range-filter.component';
import { DropDownFilterComponent } from './components/custom-filters/dropdown-filter.component';
import { MultiselectEnvironmentFilterComponent } from './components/custom-filters/multiselect-environment-filter.component';
import { MultiselectTagFilterComponent } from './components/custom-filters/multiselect-tag-filter.component';
import { CyborgEnvironmentContentComponent } from './components/cyborg-environment-content/cyborg-environment-content.component';
import { CyborgSelectComponent } from './components/cyborg-select/cyborg-select.component';
import { HuntModuleDialogComponent } from './components/dialogs/hunt-module-dialog/hunt-module-dialog.component';
import { NewTemplateDialogComponent } from './components/dialogs/new-template-dialog/new-template-dialog.component';
import { PremiumDialogComponent } from './components/dialogs/premium-dialog/premium-dialog.component';
import { TalkToCyborgDialogComponent } from './components/dialogs/talk-to-cyborg-dialog/talk-to-cyborg-dialog.component';
import { UnlockModalComponent } from './components/dialogs/unlock/unlock.component';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { FacetButtonsComponent } from './components/facet-buttons/facet-buttons.component';
import { HuntPackageOverviewComponent } from './components/hunt-package-overview/hunt-package-overview.component';
import { HuntPackageComponent } from './components/hunt-package/hunt-package.component';
import { HuntPackageTrialResolver } from './components/hunt-package/hunt-package.resolver';
import { MarkdownComponent } from './components/markdown/markdown.component';
import { QueryLogicComponent } from './components/query-logic/query-logic.component';
import { SearchSortComponent } from './components/search-sort/search-sort.component';
import { ThreatProfileComponent } from './components/threat-profiles/threat-profiles.component';
import { TrialLockUnlockComponent } from './components/trial-lock-unlock/trial-lock-unlock.component';
import { FavoriteService } from './services/favorite.service';
import { CyborgContentComponent } from './components/cyborg-content/cyborg-content.component';
import { MitreTechniqueMultiselectComponent } from './components/mitre-multiselect/mitre-multiselect.component';
import { FrameDetectionService } from './services/frame-detection.service';
import { LinkComponent, TagComponent, TypographyComponent } from '@hyperkit';

@NgModule({
  declarations: [
    DropDownFilterComponent,
    DateRangeFilterComponent,
    MultiselectTagFilterComponent,
    MultiselectEnvironmentFilterComponent,
    MarkdownComponent,
    HuntPackageComponent,
    ThreatProfileComponent,
    AllActiveFiltersComponent,
    FacetButtonsComponent,
    TrialLockUnlockComponent,
    UnlockModalComponent,
    QueryLogicComponent,
    HuntPackageOverviewComponent,
    NewTemplateDialogComponent,
    TalkToCyborgDialogComponent,
    HuntModuleDialogComponent,
    PremiumDialogComponent,
    CyborgSelectComponent,
    ContactCyborgComponent,
    ErrorMessageComponent,
    SearchSortComponent,
    CyborgEnvironmentContentComponent,
    CyborgContentComponent,
    MitreTechniqueMultiselectComponent,
  ],
  providers: [
    HuntPackageTrialResolver,
    FavoriteService,
    SearchStateService,
    FrameDetectionService,
    SearchUrlService,
  ],
  imports: [CommonModule, CyborgUIModule, RouterModule, TagComponent, TypographyComponent, LinkComponent],
  exports: [
    DropDownFilterComponent,
    DateRangeFilterComponent,
    MultiselectTagFilterComponent,
    MultiselectEnvironmentFilterComponent,
    MarkdownComponent,
    HuntPackageComponent,
    ThreatProfileComponent,
    AllActiveFiltersComponent,
    FacetButtonsComponent,
    TrialLockUnlockComponent,
    UnlockModalComponent,
    QueryLogicComponent,
    HuntPackageOverviewComponent,
    NewTemplateDialogComponent,
    TalkToCyborgDialogComponent,
    HuntModuleDialogComponent,
    PremiumDialogComponent,
    CyborgSelectComponent,
    ContactCyborgComponent,
    ErrorMessageComponent,
    SearchSortComponent,
    CyborgEnvironmentContentComponent,
    CyborgContentComponent,
    MitreTechniqueMultiselectComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {}
